// Compact, self-explanatory presentation of the platform's immutable plan
// identifier. Rendered as a pill (not a form field) so it reads as system
// metadata, never as something editable — clearly distinct from the
// carrier-assigned Plan Code / Group Number shown in the editable fields.
// Click to copy (support workflows: "which plan is this?").

import { Copy, Hash } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

export function SystemPlanIdBadge({
  planId,
  className = "",
}: {
  planId: number | string;
  className?: string;
}) {
  const { toast } = useToast();
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(String(planId));
      toast({ title: `System Plan ID ${planId} copied` });
    } catch {
      /* clipboard unavailable — the value is visible anyway */
    }
  };
  return (
    <button
      type="button"
      onClick={copy}
      title="administr's internal plan identifier — permanent, unique across the platform, and the same through every rate change. This is NOT the carrier's Plan Code / Group Number."
      className={`inline-flex w-fit items-center gap-1.5 rounded-full border bg-muted/50 px-2.5 py-0.5 text-xs font-mono text-muted-foreground transition-colors hover:bg-muted hover:text-foreground ${className}`}
    >
      <Hash className="h-3 w-3" />
      System ID {planId}
      <Copy className="h-3 w-3 opacity-50" />
    </button>
  );
}

export default SystemPlanIdBadge;
